import filter from 'lodash/filter';
import get from 'lodash/get';

export default class BankAccountEntity {
  constructor(account) {
    this.account = account;
  }

  getId() {
    return this.account.id;
  }

  getLegalEntity() {
    return get(this.account, 'details.legal_entity') || {};
  }

  getLegalEntityStatus() {
    return this.getLegalEntity().verification.status;
  }

  getExternalAccount() {
    return get(this.account, 'details.external_accounts.data[0]') || {};
  }

  getFullName() {
    return `${this.getLegalEntity().first_name} ${this.getLegalEntity().last_name}`;
  }

  getAddress() {
    return this.getLegalEntity().address;
  }

  getFormattedAddress() {
    const { line1, city, state, postal_code } = this.getLegalEntity().address || {};

    return filter([line1, city, state, postal_code]).join(', '); // eslint-disable-line
  }

  isVerified() {
    return this.getLegalEntityStatus() === 'verified';
  }

  isUnverified() {
    return this.getLegalEntityStatus() === 'unverified';
  }

  isPending() {
    return this.getLegalEntityStatus() === 'pending';
  }

  personalIdNumberProvided() {
    return this.getLegalEntity().personal_id_number_provided === true;
  }

  einProvided() {
    return this.getLegalEntity().business_tax_id_provided === true;
  }

  isCompany() {
    return this.details.business_type === 'company';
  }

  getVerificationErrors() {
    return (this.account.details.requirements.errors || []).filter(err =>
      !err.requirement.includes('additional_document')
    );
  }

  isFrontIdProvided() {
    return !!this.getLegalEntity().verification.document.front;
  }

  isBackIdProvided() {
    return !!this.getLegalEntity().verification.document.back;
  }

  isBusinessRegistrationProvided() {
    return !!get(this.details, 'company.verification.document.front');
  }
}
